import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-edit-formula-expression',
  templateUrl: './edit-formula-expression.component.html',
  styleUrls: ['./edit-formula-expression.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditFormulaExpressionComponent extends DialogDefinitionEditorBase implements OnInit {
  tagOptions: any;
  chatText: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tagOptions = this.dialogField.fieldValues['Questions'];
    this.chatText = this.dialogField.value ?? '';
  }

  onValueChange($event: string) {
    this.dialogField.value = $event;
  }

}
